import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../api/store';
import { ChatsState, MessageAttachmentData } from './chats-state';

export const initialMessageAttachmentData: MessageAttachmentData = {
    imageUrl: null,
    isLoadingImage: false,
    isImagePreviewOpen: false,
    fileUrl: null,
    isLoadingFile: false,
    isFilePreviewOpen: false,
    fileName: null,
    fileType: null,
};

const initialState: ChatsState = {
    searchTerm: '',
    message: '',
    activeMessageId: null,
    downloadingAttachmentId: null,
    selectedFile: null,
    showAttachments: false,
    isSearchOpen: false,
    selectedFilePreviewUrl: null,
    messageAttachmentData: initialMessageAttachmentData,
};

const chatsSlice = createSlice({
    name: 'chatsSlice',
    initialState,
    reducers: {
        setChatValue: <K extends keyof ChatsState>(state: ChatsState, action: PayloadAction<{ key: K; value: ChatsState[K] }>) => {
            const { key, value } = action.payload;
            state[key] = value;
        },

        clearChatValue: <K extends keyof ChatsState>(state: ChatsState, action: PayloadAction<K>) => {
            const key = action.payload;
            const currentValue = state[key];

            if (typeof currentValue === 'string') {
                state[key] = '' as ChatsState[K];
            } else if (typeof currentValue === 'boolean') {
                state[key] = false as ChatsState[K];
            } else {
                state[key] = null as ChatsState[K];
            }
        },

        setMessageAttachmentValue: <K extends keyof MessageAttachmentData>(state: ChatsState, action: PayloadAction<{ key: K; value: MessageAttachmentData[K] }>) => {
            state.messageAttachmentData[action.payload.key] = action.payload.value;
        },

        clearMessageAttachmentData: (state) => {
            state.messageAttachmentData = { ...initialMessageAttachmentData };
        },

        clearChats: (state) => {
            state.searchTerm = '';
            state.message = '';
            state.activeMessageId = null;
            state.downloadingAttachmentId = null;
            state.selectedFile = null;
            state.showAttachments = false;
            state.isSearchOpen = false;
            state.selectedFilePreviewUrl = null;
            state.messageAttachmentData = { ...initialMessageAttachmentData };
        },
    },
});

export const {
    setChatValue,
    clearChatValue,
    setMessageAttachmentValue,
    clearMessageAttachmentData,
    clearChats,
} = chatsSlice.actions;

export const selectChats = (state: RootState) => state.chatsSlice;
export const selectMessageAttachmentData = (state: RootState) => state.chatsSlice.messageAttachmentData;
export const selectChatsImgData = (state: RootState) => state.chatsSlice.messageAttachmentData.imageUrl;
export const selectChatsFileData = (state: RootState) => state.chatsSlice.messageAttachmentData.fileUrl;
export const selectChatsFileName = (state: RootState) => state.chatsSlice.messageAttachmentData.fileName;
export const selectChatsFileType = (state: RootState) => state.chatsSlice.messageAttachmentData.fileType;
export const selectIsLoadingImage = (state: RootState) => state.chatsSlice.messageAttachmentData.isLoadingImage;
export const selectIsImagePreviewOpen = (state: RootState) => state.chatsSlice.messageAttachmentData.isImagePreviewOpen;
export const selectIsLoadingFile = (state: RootState) => state.chatsSlice.messageAttachmentData.isLoadingFile;
export const selectIsFilePreviewOpen = (state: RootState) => state.chatsSlice.messageAttachmentData.isFilePreviewOpen;

export default chatsSlice.reducer;